(function ($) {

    $('body').on('click', '.nav-ecommerce-trigger,  .nav-ecommerce .close-button span', toggleClass); 

    function toggleClass(e) {
        e.preventDefault();
        var isOpenE = $(this).closest('.nav-ecommerce').hasClass('nav-ecommerce-on');
        $('.nav-chat').removeClass('nav-chat-on');
        $('.nav-ecommerce').removeClass('nav-ecommerce-on');
        if(!isOpenE) {
             $(this).closest('.nav-ecommerce').toggleClass('nav-ecommerce-on');
        }
    }

}(window.jQuery));

// Analytics

analytics.eventConfig.push({
    "target": ".nav-ecommerce",
    "codeId": "ec",
    "events": [
        {
            "eventTarget": "a.nav-ecommerce-trigger",
            "eventType": "click",
            "tags": {
                "event": "navigation",
                "componentName": "ecommerce option",
                "componentId": "ec",
                "eventType": "ecommerce option open click",
                "elementType": "ecommerce option",
                "parentName": ""

            }
        },
        {
            "eventTarget": ".close-button",
            "eventType": "click",
            "tags": {
                "componentName": "ecommerce option",
                "componentId": "ec",
                "event": "navigation",
                "eventType": "ecommerce option x out click",
                "elementType": "ecommerce option x out",
                "parentName": ""
            }
        }
    ]
});